import { buildModule, defineSingleFilter, createFiltersModule } from '../utils';

import detail from './detail';
import list from './list';
import customFields from './custom-fields';
import lazy from './lazy';
import moment from 'moment';

const DATE_FORMAT = 'YYYY-MM-DD';
const START_DATE = moment().startOf('M').format(DATE_FORMAT);

export default buildModule()
	.withSubmodules({
		detail,
		list,
		customFields,
		lazy,
		filters: createFiltersModule({
			filters: {
				from: defineSingleFilter('from', String, START_DATE),
				to: defineSingleFilter('to', String),
			},
		}),
	});
